import { Injectable } from '@angular/core';
import { Constantes } from '../../system/constantes/constantes';
import { LoadingController } from '@ionic/angular';


@Injectable()
export class Utiles 
{
  private loadingMostrado: boolean = false;

  constructor(
    private loadingController : LoadingController
  ) 
  {
    
  }

  async mostrarLoading(texto: string) 
  {
    const loading = await this.loadingController.create(
      {
        message: texto,
        duration: 8000,
        translucent: true,
      });
    await loading.present();
    this.loadingMostrado = true;
    return;
  }

  ocultarLoading(tiempoMS: number = 500) 
  {
    setTimeout(() => 
    {
      if (this.loadingMostrado) 
      {
        this.loadingMostrado = false;
        console.log('ocultarLoadin');
        return this.loadingController.dismiss();
      }
    }, tiempoMS);
  }

  public pad(num:number, size:number): string 
  {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  public sleep(ms: number) 
  {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
